import type { KartochkaZvonka, WorkplaceState, ZapisKlientki } from './workplaceApi';

/**
 * s766 (обращение техподдержки №4): что окно звонка знает о звонке — одной формой, откуда бы
 * сведения ни пришли: входящий, который станция ещё соединяет, идущий разговор или набор обзвона.
 */
export interface SvedeniyaZvonka {
  /** Ключ звонка: одно окно на один звонок, закрытое повторно не всплывает. */
  klyuch: string;
  vid: 'vhod' | 'obzvon';
  /** Номер разговора в учёте — по нему раскрывается полный номер; до ответа его ещё нет. */
  callId: number | null;
  imya: string | null;
  nomer: string | null;
  liniya: string | null;
  obzvon: string | null;
  popytka: number | null;
  popytokVsego: number | null;
  kommentariy: string | null;
  kartochka: KartochkaZvonka | null;
  zapis: ZapisKlientki | null;
  neskolko: boolean;
  zhdalSek: number | null;
}

/**
 * Звонок, который пришёл к человеку сам: входящий с линии либо соединённый обзвоном. Ручной набор
 * и звонок из карточки сюда не попадают — их человек начал сам и знает, кому звонит.
 */
export function chuzhoyZvonok(state: WorkplaceState | null): SvedeniyaZvonka | null {
  const razgovor = state?.active_call ?? null;

  if (razgovor !== null && razgovor.ruchnoy !== true && (razgovor.direction === 'inbound' || razgovor.task_id != null)) {
    const obzvon = razgovor.task_id != null;

    return {
      klyuch: `call:${razgovor.call_id}`,
      vid: obzvon ? 'obzvon' : 'vhod',
      callId: razgovor.call_id,
      imya: razgovor.contact_name || null,
      nomer: razgovor.client_phone || null,
      liniya: razgovor.line ?? null,
      obzvon: obzvon ? (razgovor.source ?? null) : null,
      popytka: obzvon ? (razgovor.popytka ?? null) : null,
      popytokVsego: obzvon ? (razgovor.popytok_vsego ?? null) : null,
      kommentariy: razgovor.kommentariy ?? null,
      kartochka: razgovor.kartochka ?? null,
      zapis: razgovor.zapis ?? null,
      neskolko: razgovor.neskolko === true,
      zhdalSek: null,
    };
  }

  const vhod = state?.vhodyashchiy ?? null;

  if (vhod !== null) {
    return {
      klyuch: `vhod:${vhod.key}`,
      vid: 'vhod',
      callId: null,
      imya: vhod.contact_name || null,
      nomer: vhod.client_phone,
      liniya: vhod.line,
      obzvon: null,
      popytka: null,
      popytokVsego: null,
      kommentariy: null,
      kartochka: vhod.kartochka,
      zapis: vhod.zapis,
      neskolko: vhod.neskolko,
      zhdalSek: vhod.zhdal_sek,
    };
  }

  return null;
}

/** Станция набирает клиентку для этого места (обзвон или автоперезвон) — трубку ещё не сняли. */
export function naborObzvona(state: WorkplaceState | null): SvedeniyaZvonka | null {
  const nabor = state?.nabor ?? null;

  if (nabor === null || nabor.ruchnoy) return null;

  return {
    klyuch: `nabor:${nabor.attempt_id}`,
    vid: 'obzvon',
    callId: null,
    imya: nabor.contact_name || null,
    nomer: nabor.client_phone || null,
    liniya: nabor.line ?? null,
    obzvon: nabor.source,
    popytka: nabor.popytka,
    popytokVsego: nabor.popytok_vsego,
    kommentariy: nabor.kommentariy,
    kartochka: nabor.kartochka,
    zapis: null,
    neskolko: false,
    zhdalSek: null,
  };
}

/** Сервер говорит: этот звонок человек начал сам (из карточки, с выбранной линии, перезвон кнопкой). */
export function svoyPoServeru(state: WorkplaceState | null): boolean {
  return state?.active_call?.ruchnoy === true || state?.nabor?.ruchnoy === true;
}
